export const inIframe = () => window !== window.parent;
